export default __webpack_public_path__ + "4670ee5b73cf46daca000893905b65ce.PNG";